<div class="logements-page">
  <a
    [routerLink]="backToBien"
    class="logements-back"
    [title]="'dossierTechnique.backToBien' | translate"
    [attr.aria-label]="'dossierTechnique.backToBien' | translate"
  >
    <fa-icon icon="arrow-left"></fa-icon>
  </a>

  @if (loading) {
    <p class="logements-status">{{ 'common.loading' | translate }}</p>
  }
  @if (errorKey) {
    <p class="logements-status logements-status--error">
      {{ errorKey | translate }}
    </p>
  }

  @if (!loading && !errorKey && bien && logement) {
    <header class="logements-header">
      <h2 class="logements-title">
        {{ 'dossierTechnique.title' | translate }}
      </h2>
      <p class="logements-subtitle">{{ bien.titreDto }}</p>
      <p class="logements-subtitle">
        {{ titreUnite }}
        @if (detailsUnite) {
          <span> · {{ detailsUnite }}</span>
        }
      </p>
    </header>

    @if (listReloadError) {
      <p class="logements-status logements-status--error">
        {{ 'dossierTechnique.reloadError' | translate }}
      </p>
    }

    <section class="logements-section">
      <ul class="logements-list">
        @for (ligne of lignes; track ligne.type) {
          <li
            class="logements-row"
            [class.logements-row--expire]="ligne.statut === 'expire'"
            [class.logements-row--na]="!ligne.exigible && !ligne.document"
          >
            <div class="logements-row-main">
              <h4 class="logements-row-title">
                <span>
                  {{ 'dossierTechnique.types.' + ligne.type | translate }}
                </span>
                <span
                  class="dossier-status"
                  [class.dossier-status--ok]="ligneOk(ligne)"
                  [class.dossier-status--ko]="!ligneOk(ligne)"
                  [title]="
                    (ligneOk(ligne)
                      ? 'dossierTechnique.ligneOk'
                      : 'dossierTechnique.ligneKo'
                    ) | translate
                  "
                  [attr.aria-label]="
                    (ligneOk(ligne)
                      ? 'dossierTechnique.ligneOk'
                      : 'dossierTechnique.ligneKo'
                    ) | translate
                  "
                >
                  <fa-icon
                    [icon]="ligneOk(ligne) ? 'check' : 'xmark'"
                  ></fa-icon>
                </span>
              </h4>
              <p>
                {{ 'dossierTechnique.statut.' + ligne.statut | translate }}
                @if (resultatLabel(ligne); as resultatKey) {
                  <span> · {{ resultatKey | translate }}</span>
                }
                @if (fileLabel(ligne)) {
                  <span> · {{ fileLabel(ligne) }}</span>
                }
              </p>
              @if (!ligne.exigible) {
                <p class="dossier-hint">
                  {{ nonApplicableHint(ligne) | translate }}
                </p>
              }
              @if (diagnosticLabel(ligne) || expirationLabel(ligne)) {
                <p class="dossier-meta">
                  @if (diagnosticLabel(ligne)) {
                    <span>
                      {{ 'dossierTechnique.diagnostic' | translate }}
                      {{ diagnosticLabel(ligne) }}
                    </span>
                  }
                  @if (expirationLabel(ligne)) {
                    <span>
                      {{ 'dossierTechnique.expiration' | translate }}
                      {{ expirationLabel(ligne) }}
                    </span>
                  }
                </p>
              }
            </div>
            <div class="logements-row-actions">
              @if (ligne.document) {
                <button
                  type="button"
                  class="logements-row-action"
                  [title]="'dossierTechnique.view' | translate"
                  [attr.aria-label]="'dossierTechnique.view' | translate"
                  [disabled]="isBusy"
                  (click)="openViewer(ligne)"
                >
                  <fa-icon icon="eye"></fa-icon>
                </button>
                <button
                  type="button"
                  class="logements-row-action"
                  [title]="'dossierTechnique.editExpiration' | translate"
                  [attr.aria-label]="'dossierTechnique.editExpiration' | translate"
                  [disabled]="isBusy"
                  (click)="openExpiration(ligne)"
                >
                  <fa-icon icon="calendar-days"></fa-icon>
                </button>
              }
              <button
                type="button"
                class="logements-row-action"
                [title]="
                  !ligne.exigible
                    ? (nonApplicableHint(ligne) | translate)
                    : (ligne.document
                        ? 'dossierTechnique.replace'
                        : 'dossierTechnique.upload'
                      ) | translate
                "
                [attr.aria-label]="
                  !ligne.exigible
                    ? (nonApplicableHint(ligne) | translate)
                    : (ligne.document
                        ? 'dossierTechnique.replace'
                        : 'dossierTechnique.upload'
                      ) | translate
                "
                [disabled]="isBusy || !ligne.exigible"
                (click)="openUpload(ligne)"
              >
                <fa-icon [icon]="ligne.document ? 'arrows-rotate' : 'upload'"></fa-icon>
              </button>
              @if (ligne.document) {
                <button
                  type="button"
                  class="logements-row-action logements-row-action--danger"
                  [title]="'common.delete' | translate"
                  [attr.aria-label]="'common.delete' | translate"
                  [disabled]="isBusy"
                  (click)="askDelete(ligne)"
                >
                  <fa-icon [icon]="['far', 'trash-can']"></fa-icon>
                </button>
              }
            </div>
          </li>
        }
      </ul>
    </section>
  }

  <dialog
    #uploadDialog
    class="logements-dialog"
    aria-labelledby="upload-document-title"
    (cancel)="onUploadDialogCancel($event)"
  >
    @if (uploadType) {
      <h3 id="upload-document-title">
        {{
          (uploadIsReplace
            ? 'dossierTechnique.replaceTitle'
            : 'dossierTechnique.uploadTitle'
          ) | translate
        }}
      </h3>
      <p>
        {{ 'dossierTechnique.types.' + uploadType | translate }}
      </p>

      <form
        class="logements-form"
        [formGroup]="uploadForm"
        (ngSubmit)="submitUpload()"
      >
        <label [class.is-invalid]="uploadFileError">
          {{ 'dossierTechnique.file' | translate }}
          <input
            type="file"
            accept=".pdf,application/pdf,image/*"
            (change)="onFileSelected($event)"
          />
          <span class="dossier-file-hint">
            {{ 'dossierTechnique.fileHint' | translate }}
          </span>
          @if (uploadFile) {
            <span class="dossier-file-name">{{ uploadFile.name }}</span>
          }
          @if (uploadFileError) {
            <span class="logements-field-error">
              {{ 'dossierTechnique.fileRequired' | translate }}
            </span>
          }
        </label>

        <label
          [class.is-invalid]="
            uploadForm.controls.dateDiagnostic.invalid &&
            uploadForm.controls.dateDiagnostic.touched
          "
        >
          {{ 'dossierTechnique.dateDiagnostic' | translate }}
          <input type="date" formControlName="dateDiagnostic" />
          @if (
            uploadForm.controls.dateDiagnostic.invalid &&
            uploadForm.controls.dateDiagnostic.touched
          ) {
            <span class="logements-field-error">
              {{ 'dossierTechnique.dateDiagnosticRequired' | translate }}
            </span>
          }
        </label>

        @if (uploadNeedsResultat) {
          <label
            [class.is-invalid]="
              uploadForm.controls.resultat.invalid &&
              uploadForm.controls.resultat.touched
            "
          >
            {{ 'dossierTechnique.resultat' | translate }}
            <select formControlName="resultat">
              <option value="">{{ 'common.choose' | translate }}</option>
              @for (resultat of resultats; track resultat) {
                <option [value]="resultat">
                  {{ 'dossierTechnique.resultats.' + resultat | translate }}
                </option>
              }
            </select>
            @if (
              uploadForm.controls.resultat.invalid &&
              uploadForm.controls.resultat.touched
            ) {
              <span class="logements-field-error">
                {{ 'dossierTechnique.resultatRequired' | translate }}
              </span>
            }
          </label>
        }

        @if (uploadErrorMessage) {
          <p class="logements-status logements-status--error">
            {{ uploadErrorMessage }}
          </p>
        }

        <div class="logements-dialog-actions">
          <button
            type="button"
            class="logements-cancel"
            [disabled]="uploading"
            (click)="cancelUpload()"
          >
            {{ 'common.cancel' | translate }}
          </button>
          <button
            type="submit"
            class="logements-action-btn"
            [disabled]="uploading"
          >
            {{
              uploading
                ? ('dossierTechnique.uploading' | translate)
                : uploadIsReplace
                  ? ('dossierTechnique.replace' | translate)
                  : ('dossierTechnique.upload' | translate)
            }}
          </button>
        </div>
      </form>
    }
  </dialog>

  <app-document-delete-dialog
    i18nPrefix="dossierTechnique"
    [active]="deleteSession.active"
    [typeLabel]="deleteTypeLabel"
    [fileName]="deleteFileName"
    [deleting]="deleteSession.deleting"
    [errorMessage]="deleteSession.errorMessage"
    (cancelRequest)="cancelDelete()"
    (confirmRequest)="confirmDelete()"
    (dialogCancel)="onDeleteDialogCancel($event)"
  />

  <dialog
    #expirationDialog
    class="logements-dialog"
    aria-labelledby="expiration-document-title"
    (cancel)="onExpirationDialogCancel($event)"
  >
    @if (expirationLigne) {
      <h3 id="expiration-document-title">
        {{ 'dossierTechnique.expirationTitle' | translate }}
      </h3>
      <p>
        {{ 'dossierTechnique.types.' + expirationTypeLabel | translate }}
      </p>

      <form
        class="logements-form"
        [formGroup]="expirationForm"
        (ngSubmit)="submitExpiration()"
      >
        <label class="logements-check">
          <input
            type="checkbox"
            formControlName="unlimited"
            (change)="onUnlimitedChange()"
          />
          {{ 'dossierTechnique.expirationUnlimited' | translate }}
        </label>

        <label
          [class.is-invalid]="
            !expirationUnlimited &&
            expirationForm.controls.dateExpiration.invalid &&
            expirationForm.controls.dateExpiration.touched
          "
        >
          {{ 'dossierTechnique.dateExpiration' | translate }}
          <input type="date" formControlName="dateExpiration" />
          @if (
            !expirationUnlimited &&
            expirationForm.controls.dateExpiration.invalid &&
            expirationForm.controls.dateExpiration.touched
          ) {
            <span class="logements-field-error">
              {{ 'dossierTechnique.dateExpirationRequired' | translate }}
            </span>
          }
        </label>

        @if (expirationErrorMessage) {
          <p class="logements-status logements-status--error">
            {{ expirationErrorMessage }}
          </p>
        }

        <div class="logements-dialog-actions">
          <button
            type="button"
            class="logements-cancel"
            [disabled]="savingExpiration"
            (click)="cancelExpiration()"
          >
            {{ 'common.cancel' | translate }}
          </button>
          <button
            type="submit"
            class="logements-action-btn"
            [disabled]="savingExpiration"
          >
            {{
              savingExpiration
                ? ('common.saving' | translate)
                : ('common.save' | translate)
            }}
          </button>
        </div>
      </form>
    }
  </dialog>

  <app-document-viewer-dialog
    i18nPrefix="dossierTechnique"
    [session]="viewer"
    (download)="downloadViewerFile()"
    (closeRequest)="closeViewer()"
    (openExternally)="openViewerExternally()"
    (dialogCancel)="onViewerDialogCancel($event)"
  />
</div>
